// @ts-nocheck
import React from 'react';

const ParafiaPage = () => {
  return (
    <>
      <section className="pt-2 pb-10">
        <div className="container md:px-[65px]">
          <div className="flex flex-col-reverse text-white md:flex-row">
            <div className="relative md:w-3/5 bg-[#A81414] md:h-[450px] px-6 py-2 md:p-8 md:rounded-tl-xl rounded-bl-xl max-md:rounded-br-xl">
              <h2 className="py-3 text-xl font-bold text-justify uppercase md:text-4xl hyphens-auto">Парафія</h2>
              <div className="pt-3 pb-3 max-md:leading-5 md:pl-8 hyphens-auto">
                Парафія є обличчям Церкви. Це точка відліку, яка робить церкву видимою та соціально-включеною в щоденне життя. Парафія є спільнотою, яка супроводжує вибір покликання вірних, особливо молоді. Апостольська ревність отця Боско для найбіднішої молоді Турина спонукала його створити парафію для молоді без парафії. Сам отець Боско свого часу прийняв сім парафій. У 1887 році він написав положення про правильне функціонування парафії.
              </div>
              <div className="pt-3 pb-3 md:pl-8 hyphens-auto max-md:leading-5">
                Він торкнувся тих питань, які його найбільше хвилюють: першочергова увага до молоді, особливо найбіднішої, та ідентичність салезіянського пароха, який служить там у сопричасті з єпископом і єпархіальним духовенством.
                Для нас, салезіян, парафія є середовищем, в якому ми знаходимо широкі можливості та сприятливі умови для навчання молоді робітничого класу чи з бідного середовища.

              </div>
            </div>
            <div className="relative md:w-2/5">
              <div class="hidden md:block absolute md:top-1/2 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[20px] border-b-[20px] border-l-[10px]
              md:border-t-[225px] md:border-b-[225px] md:border-l-[100px]
              border-t-transparent border-b-transparent border-l-red-600">
              </div>
              <div class="md:hidden block absolute bottom-0 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-b-[30px] border-l-[calc(50vw-20px)] border-r-[calc(50vw-20px)]
              md:border-t-[225px] md:border-b-[225px] md:border-l-[100px]
              border-l-transparent border-r-transparent border-t-transparent border-t-red-600">
              </div>
              <img
                className="md:h-[450px] object-cover object-right rounded-tr-xl md:rounded-br-xl rounded-tl-xl md:rounded-tl-none"
                src="/images/parafia.JPG"
                alt=""
              />
            </div>
          </div>
          <div className="flex flex-col items-center mt-4 md:mt-8 md:pl-16 md:flex-row">

            <div className="relative md:w-1/2">
              <div>

              </div>
              <div class="hidden md:block absolute top-1/2 right-0 -translate-y-1/2 border-[#A81414] 
              w-0 h-0
              border-t-[40px] border-b-[40px] border-r-[20px]
              border-t-transparent border-b-transparent border-l-red-600">
              </div>
            </div>
            <div className="max-md:mb-8 max-md:mt-4 relative max-md:ml-[28px] md:w-2/3 bg-[#A81414] md:h-[80px] flex justify-center items-center px-2 md:px-8 rounded-tr-xl rounded-br-xl">
              <div class="md:hidden absolute top-1/2 -left-[22px] -translate-y-1/2 border-[#A81414] 
              w-0 h-0
              border-t-[42px] border-b-[42px] border-r-[22px]
              border-t-transparent border-b-transparent border-l-red-600">
              </div>
              <h3 className="text-[14px] items-center flex  justify text-white uppercase text- nt-bold hyphens-auto max-md:leading-4 max-md:py-[10px]">
                В Україні при парафії Покрови Пресвятої Богородиці у м.Львові діє ораторія святого Домініка Савіо. Вона є невід'ємною частиною життя парафії.
              </h3>
            </div>
          </div>


          <div className="flex">
            <div className="relative w-[90%] md:w-2/5 bg-[#A81414] h-[80px] flex justify-start items-center pl-[24px] md:pl-8 rounded-tl-xl rounded-bl-xl">
              <h3 className="text-2xl text-justify text-white uppercase md:text-4xl nt-bold hyphens-auto">Салезіянські парафії</h3>
            </div>
            <div className="relative md:w-3/5">
              <div class="absolute top-1/2 left-0 -translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[40px] border-b-[40px] border-l-[20px]
              border-t-transparent border-b-transparent border-l-red-600">
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-between py-4 md:px-16 md:flex-row">
            <div className="">
              <div className="text-[#A81414] font-bold pt-2 text-lg md:text-xl">
                ПАРАФІЯ ПОКРОВИ ПРЕСВЯТОЇ БОГОРОДИЦІ
              </div>
              <div className="flex my-2 max-md:ml-4">
                <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
                </div>
                <div>
                  <div className="">
                    Львів
                  </div>
                </div>
              </div>
              <div className="">
                <a
                  href="https://map.ugcc.ua/view/279-tserkva-pokrovu-presvyatoy-bogorodytsi-lviv"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ➤  <span className="underline">Історія парафії</span>

                </a>
              </div>
            </div>
            <div className="hidden md:flex border-[2px] border-[#A81414] mx-16">
            </div>
            {/* <div className=" border-[2px] border-[#A81414]">
            </div> */}
            <div className="">
              <div className="text-[#A81414] font-bold pt-2 text-lg md:text-xl">
                ПАРАФІЯ ПОКРОВИ ПРЕСВЯТОЇ БОГОРОДИЦІ
              </div>

              <div className="flex my-2 max-md:ml-4">
                <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
                </div>
                <div>
                  <div className="">
                    с. Раковець
                  </div>
                </div>

              </div>
              <div className="">
                <a
                  href="https://map.ugcc.ua/view/3182-tserkva-pokrovy-presvyatoy-bogorodytsi-s-rakovets-lvivska-oblast"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ➤  <span className="underline">Історія парафії</span>

                </a>
              </div>
            </div>
            <div className="hidden md:flex border-[2px] border-[#A81414] mx-16">
            </div>
            {/* <div className=" border-[2px] border-[#A81414]">
            </div> */}
            <div className="">
              <div className="text-[#A81414] font-bold pt-2 text-lg md:text-xl">
                ПАРАФІЯ ПОЛОЖЕННЯ РИЗИ ПРЕСВЯТОЇ БОГОРОДИЦІ
              </div>
              <div className="flex my-2 max-md:ml-4">
                <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
                </div>
                <div>
                  <div className="">
                    с. Новосілка
                  </div>
                </div>
              </div>
              <div className="">
                <a
                  href="https://map.ugcc.ua/view/3154-tserkva-polozhennya-ryzy-presvyatoy-bogorodytsi-s-novosilka-lvivska-oblast"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ➤  <span className="underline">Історія парафії</span>

                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="pt-6 pb-10">
        <div className="container px-[65px]">
          <div className="flex text-white">
            <div className="relative w-3/5 bg-[#A81414] h-[450px] p-8 rounded-tl-xl rounded-bl-xl ">
              <h2 className="py-3 text-4xl font-bold text-justify uppercase hyphens-auto">
                Парафія
              </h2>
              <div className="pt-3 pb-3 pl-8 hyphens-auto">
                Парафія є обличчям Церкви. Це точка відліку, яка робить церкву видимою та соціально-включеною в щоденне життя. Парафія є спільнотою, яка супроводжує вибір покликання вірних, особливо молоді. Апостольська ревність отця Боско для найбіднішої молоді Турина спонукала його створити парафію для молоді без парафії. Сам отець Боско свого часу прийняв сім парафій. У 1887 році він написав положення про правильне функціонування парафії.

              </div>
              <div className="pt-3 pb-3 pl-8 hyphens-auto">
                Він торкнувся тих питань, які його найбільше хвилюють: першочергова увага до молоді, особливо найбіднішої, та ідентичність салезіянського пароха, який служить там у сопричасті з єпископом і єпархіальним духовенством.
                Для нас, салезіян, парафія є середовищем, в якому ми знаходимо широкі можливості та сприятливі умови для навчання молоді робітничого класу чи з бідного середовища.

              </div>
            </div>
            <div className="relative w-2/5">
              <div class="absolute top-1/2 left-0 -translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[225px] border-b-[225px] border-l-[100px]
              border-t-transparent border-b-transparent border-l-red-600">
              </div>
              <img
                className="h-[450px] object-cover object-right rounded-tr-xl rounded-br-xl"
                src="/images/parafia.JPG"
                alt=""
              />
            </div>
          </div>
          <div className="flex items-center pl-16">

            <div className="relative w-1/2">
              <div>

              </div>
              <div class="mt-4 absolute top-1/2 right-0 -translate-y-1/2 border-[#A81414] 
              w-0 h-0
              border-t-[40px] border-b-[40px] border-r-[40px]
              border-t-transparent border-b-transparent border-l-red-600">
              </div>
            </div>
            <div className="mt-8 relative w-2/3 bg-[#A81414] h-[80px] flex justify-center items-center px-8 rounded-tr-xl rounded-br-xl">
              <h3 className="text-[14px] justify text-white uppercase text- nt-bold hyphens-auto">
                В Україні при парафії Покрови Пресвятої Богородиці у м.Львові діє ораторія святого Домініка Савіо. Вона є невід'ємною частиною життя парафії.
              </h3>
            </div>
          </div>


          <div className="flex">
            <div className="relative w-2/5 bg-[#A81414] h-[80px] flex justify-start items-center pl-8 rounded-tl-xl rounded-bl-xl">
              <h3 className="text-4xl text-justify text-white uppercase nt-bold hyphens-auto">
                Салезіянські парафії
              </h3>
            </div>
            <div className="relative w-3/5">
              <div class="absolute top-1/2 left-0 -translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[40px] border-b-[40px] border-l-[40px]
              border-t-transparent border-b-transparent border-l-red-600">
              </div>
            </div>
          </div>
          <div className="flex justify-between px-16 py-4">
            <div className="">
              <div className="text-[#A81414] font-bold pt-2 text-xl">
                ПАРАФІЯ ПОКРОВИ ПРЕСВЯТОЇ БОГОРОДИЦІ
              </div>
              <div className="">
                м. Львів
              </div>
            </div>
            <div className="border-[2px] border-[#A81414] mx-16">
            </div>
            <div className="">
              <div className="text-[#A81414] font-bold pt-2 text-xl">
                ПАРАФІЯ РІЗДВА ПРЕСВЯТОЇ БОГОРОДИЦІ
              </div>
              <div className="">
                с. Раковець
              </div>
            </div>
            <div className="border-[2px] border-[#A81414] mx-16">
            </div>
            <div className="">
              <div className="text-[#A81414] font-bold pt-2 text-xl">
                ПАРАФІЯ РИЗИ ПРЕСВЯТОЇ БОГОРОДИЦІ
              </div>

              <div className="">
                с. Новосілка
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default ParafiaPage;
